import { render } from "./FullTrainingView.vue?vue&type=template&id=2c44425e"
import script from "./FullTrainingView.vue?vue&type=script&lang=js"
export * from "./FullTrainingView.vue?vue&type=script&lang=js"

import "./FullTrainingView.vue?vue&type=style&index=0&id=2c44425e&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__